export default __webpack_public_path__ + "static/media/betslipEmpty.b5aa03e9.png";